/**
 * A js file containing exports that relate to
 * the functionality and styles for break points in components.
 * @object
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */
var size = {
  small: '607px',
  medium: '768px',
  large: '1025px',
  xLarge: '1200px'
};
var forSize = {
  small: "(min-width: ".concat(size.small, ")"),
  medium: "(min-width: ".concat(size.medium, ")"),
  large: "(min-width: ".concat(size.large, ")"),
  xLarge: "(min-width: ".concat(size.xLarge, ")")
};
export default forSize;